module.exports = __webpack_public_path__ + "static/media/Florian Vollmer.9df40d89.png";